import { Component, Vue } from 'vue-property-decorator';
import AppBerichtenVue from '../hypotheek/berichten/AppBerichten.vue';

@Component({
  components: {
    'app-berichten': AppBerichtenVue
  }
})
export default class HypotheekNotFound extends Vue {}
